<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="订单号" name="order_number"></c-form-item>
                    <c-form-item type="input" label="商品信息" name="product_info" placeholder="商品名、规格"></c-form-item>
                    <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="商品名、规格"></c-form-item>
                    <c-form-item type="input" label="用户手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
                    <c-form-item type="datetime" label="评价时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="stateType"></c-form-item>
                    <c-form-item type="checkbox" label="" name="isFile" :options="[{name: '有图/视频',value: 1}]"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button power="b_order_evaluate_state"  @click="disableActivity(2)" color="m" >批量启用</c-button>
                <c-button power="b_order_evaluate_state"  @click="disableActivity(1)" color="red">批量禁用</c-button>
                <c-button power="b_order_evaluate_remove"  @click="del()" color="sys">批量删除</c-button>
            </m-operate>
            <c-table ref="table" code="order_evaluate_list">
                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="start_state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 1" style="color:red">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="置顶"
                        name="start_state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_top == 1" style="color:red">置顶</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="订单号"
                        name="order_number"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="300"
                >
                    <template v-slot="{data}">
                        <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                        <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>

                <c-table-column
                        label="商品规格"
                        name="product_sku_spec"
                        width="120"
                >
                </c-table-column>

                <c-table-column
                        label="SKU编码"
                        name="product_sku_code"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="用户昵称"
                        name="nick_name"
                ></c-table-column>

                <c-table-column
                        label="用户手机号"
                        name="user_manage_mobilephone"
                        width="110"
                ></c-table-column>

                <c-table-column
                        label="评分"
                        name="score"
                        width="50"
                ></c-table-column>

                <c-table-column
                        label="评价内容"
                        name="evaluate_comment"
                        width="180"
                ></c-table-column>

                <c-table-column
                        label="评价时间"
                        name="pj_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="置顶时间"
                        name="top_date"
                        width="140"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_top &&data.top_date">{{data.top_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
				
				<c-table-column
				        label="图片/视频"
				        width="170"
				>
				    <template v-slot="{data}">
						<div class="img-list flex-wrap" v-if="data.file_urls">
							<div v-for="(item, j) in (data.file_urls.split(','))" :key="j" style="margin-right: 5px;">
							  <c-image class="img" :src="item" size="45" preview></c-image>
							</div>
						</div>
						
				    </template>
				</c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
						width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button @click="navigateTo(`/order_evaluate_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 2" @click="disableActivity(1,data)">禁用</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.state == 1" @click="disableActivity(2,data)">启用</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.is_top == 0" @click="editIsTop(1,data)">置顶</c-table-button>
                        <c-table-button power="b_order_evaluate_state" v-if="data.is_top == 1" @click="editIsTop(0,data)">取消置顶</c-table-button>
                        <c-table-button power="b_order_evaluate_remove"  @click="del(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    import productInfo from "@/components/public/product_info.vue";

    export default {
        name: 'm_order_evaluate',
        components: {productInfo},

        computed: {
            stateText() {
                var state = {};
                this.stateType.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        data() {
            return {

                stateType: [{
                    name: '禁用',
                    value: 1
                },{
                    name: '启用',
                    value: 2
                }
                ]
            }
        },

        mounted() {
            this.$refs.search.search();


        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/orderEvaluate/list',
                    data
                });
            },

            disableActivity(state,item) {
                this._auditProductIds = [];
                var tip = "";
                if (item){
                    tip = state == 2 ? '确定要启用此评价吗？' : '确定要禁用此评价吗';
                    this._auditProductIds = [];
                    this._auditProductIds.push(item.id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的记录'
                        });
                        return;
                    }
                    var flag = true;
                    list.forEach(function(item, index, array) {
                        if((state == 1 && item.data.state == 1)||(state == 2 && item.data.state == 2)){
                            flag = false;
                        }
                    });

                    if(!flag){
                        this.$message({
                            text: state == 1?'请选择【启用】状态的记录进行禁用操作！':'请选择【禁用】状态的记录进行启用操作'
                        });
                        return false;
                    }
                    tip = state == 2 ? '确定要启用【'+list.length+'】条评价吗？' : '确定要禁用【'+list.length+'】条评价吗';
                    this._auditProductIds = Array.from(list,item=>{
                        return item.data.id;
                    })
                }

                this.$confirm({
                    text: tip,
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/updateState',
                            data: {
                                ids: this._auditProductIds,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '启用成功' :'禁用成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            editIsTop(state,item) {
                this._auditProductIds = [];
                var tip = "";
                if (item){
                    tip = state == 1 ? '确定要将该评价置顶吗？' : '确定要将该评价取消置顶吗';
                    this._auditProductIds = [];
                    this._auditProductIds.push(item.id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的记录'
                        });
                        return;
                    }
                    var flag = true;
                    list.forEach(function(item, index, array) {
                        if((state == 1 && item.data.is_top == 1)||(state == 0 && item.data.is_top == 0)){
                            flag = false;
                        }
                    });

                    if(!flag){
                        this.$message({
                            text: state == 1?'请选择【未置顶】状态的记录进行禁用操作！':'请选择【置顶】状态的记录进行启用操作'
                        });
                        return false;
                    }
                    tip = state == 1 ? '确定要将【'+list.length+'】条评价置顶吗？' : '确定要将所选的【'+list.length+'】条评价取消置顶吗';
                    this._auditProductIds = Array.from(list,item=>{
                        return item.data.id;
                    })
                }

                this.$confirm({
                    text: tip,
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/updateIsTopState',
                            data: {
                                ids: this._auditProductIds,
                                is_top: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 1 ? '置顶成功' :'取消置顶成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            del(item) {

                this._auditProductIds = [];
                var tip = "";
                if (item){
                    tip = '是否确定删除该评价？';
                    this._auditProductIds = [];
                    this._auditProductIds.push(item.id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的记录'
                        });
                        return;
                    }
                    this._auditProductIds = Array.from(list,item=>{
                        return item.data.id;
                    });
                    tip ='确定要将选中的【'+list.length+'】条评价删除吗？';
                }

                this.$confirm({
                    text: tip,
                    resolve: () => {
                        this.request({
                            url: '/orderEvaluate/remove',
                            data: {
                                ids: this._auditProductIds,
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除评论成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>
